import Leaf from './treeLeaf';

export default Leaf;
